'use client';

import { useTranslationStore } from '@/stores';
import { InputHTMLAttributes, useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { EpInput } from '../../../../components/EpInput';
import { useTranslation as t } from '../../../../hooks/useTranslation';
import style from '../../Forms/IncidentNotification/FormIncidentNotification.module.scss';
import { EpErrorMessage } from '../EpErrorMessage';

interface EpFormInputProps extends InputHTMLAttributes<HTMLInputElement> {
  inputId?: string;
  inputType?: string;
  inputName: string;
  inputRequired?: boolean;
  inputAutocomplete?: 'on' | 'off';
  inputAriaDescribedby?: string;
  inputSize?: 'sm' | 'md' | 'lg';
  inputMaxValue?: number;
  inputMinValue?: number;
  inputMaxLength?: number;
  inputMinLength?: number;
  inputWidth?: number;
  inputAddonLeftText?: string;
  inputAddonRightText?: string;
  inputIsFullWidth?: boolean;
  inputIsDisabled?: boolean;
  inputWithError?: boolean;
  inputPlaceholder?: string;
  inputHasIcon?: boolean;
  inputIconName?: string;
  customClasses?: string;
  translations?: string[];
  inputPattern?: RegExp;
  errorMessage?: string;
  inputOnChangeFunc?: (arg?: unknown) => void;
}

export const EpFormInput = ({
  inputName,
  inputRequired,
  inputMaxLength,
  inputMaxValue,
  inputMinValue,
  inputMinLength,
  inputIsFullWidth,
  inputAddonRightText,
  inputAddonLeftText,
  inputWithError = false,
  inputSize = 'md',
  inputType,
  inputPattern,
  errorMessage = '* Required Fied',
  inputOnChangeFunc,
  ...props
}: EpFormInputProps) => {
  const {
    translations: { global: globalTranslations },
  } = useTranslationStore();
  const { register, getValues, formState: { errors } } = useFormContext();
  const [textLenght, setTextLenght] = useState(getValues(inputName) || '');

  let inputPatternValues = undefined;

  if (inputPattern)
    inputPatternValues = {
      value: inputPattern,
      message: t(
        globalTranslations,
        'This value are incompatible with this field',
      ),
    };

  return (
    <>
      <EpInput
        inputName={inputName}
        inputId={inputName}
        inputSize={inputSize}
        inputAddonLeftText={inputAddonLeftText}
        inputAddonRightText={inputAddonRightText}
        inputMaxValue={inputMaxValue ? inputMaxValue : undefined}
        inputMinValue={inputMinValue ? inputMinValue : undefined}
        inputMaxLength={inputMaxLength ? inputMaxLength : undefined}
        inputMinLength={inputMinLength ? inputMinLength : undefined}
        inputIsFullWidth={inputIsFullWidth}
        inputType={inputType}
        inputOnChangeFunc={inputOnChangeFunc}
        inputWithError={inputWithError || !!errors[inputName]}
        {...props}
        {...register(`${inputName}` as const, {
          required: {
            value: inputRequired || false,
            message: t(globalTranslations, errorMessage),
          },
          pattern: inputPatternValues,

          onChange: (e) => {
            setTextLenght(e.target.value);
            {
              inputOnChangeFunc && inputOnChangeFunc(e);
            }
          },
        })}
      ></EpInput>
      {inputMaxLength && (
        <span className={style['card__txt']}>
          {t(globalTranslations, 'Number of remaining characters:')}{' '}
          {inputMaxLength - textLenght.length}
        </span>
      )}
      <EpErrorMessage inputName={inputName} />
    </>
  );
};
